const _excluded = ["children", "detectUrls"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import propTypes from '@styled-system/prop-types';
import PropTypes from 'prop-types';
import styledC from 'styled-components';
import { space, color, typography as typographySystem, system } from 'styled-system';
import A from '@adsk/alloy-react-a';
import { typography, propTypes as themePropTypes } from '../Theme';
export const textPropTypes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, propTypes.space), propTypes.color), propTypes.typography), themePropTypes.color), themePropTypes.typography), {}, {
  detectUrls: PropTypes.bool
});
const parseTextWithUrls = text => {
  if (!text) return null;
  const urlRegex = /(https?:\/\/|www\.)[^\s]+/g;
  const parts = [];
  let lastIndex = 0;
  let match;
  urlRegex.lastIndex = 0;
  while ((match = urlRegex.exec(text)) !== null) {
    const url = match[0];
    const startIndex = match.index;
    if (startIndex > lastIndex) {
      parts.push(text.substring(lastIndex, startIndex));
    }
    const punctuationMatch = url.match(/[.,;:!?)]$/);
    let displayUrl = url;
    let trailingPunctuation = '';
    if (punctuationMatch) {
      trailingPunctuation = punctuationMatch[0];
      displayUrl = url.slice(0, -1);
    }
    const linkHref = displayUrl.startsWith('www.') ? `https://${displayUrl}` : displayUrl;
    parts.push(/*#__PURE__*/React.createElement(A, {
      key: `link-${startIndex}`,
      href: linkHref,
      target: "_blank",
      style: {
        textDecoration: 'underline'
      }
    }, displayUrl));
    if (trailingPunctuation) {
      parts.push(trailingPunctuation);
    }
    lastIndex = startIndex + url.length;
  }
  if (lastIndex < text.length) {
    parts.push(text.substring(lastIndex));
  }
  return parts.length ? parts : text;
};
const processMixedContent = children => {
  if (!children) return children;
  return React.Children.map(children, child => typeof child === 'string' ? parseTextWithUrls(child) : child);
};
const StyledText = styledC.span.withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-16fwuj7-0"
})(space, color, typography, typographySystem, system({
  textTransform: true,
  whiteSpace: true,
  wordBreak: true
}));
const Text = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      children,
      detectUrls = true
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!detectUrls) {
    return /*#__PURE__*/React.createElement(StyledText, _extends({
      ref: ref
    }, props), children);
  }
  if (typeof children === 'string') {
    return /*#__PURE__*/React.createElement(StyledText, _extends({
      ref: ref
    }, props), parseTextWithUrls(children));
  }
  if (/*#__PURE__*/React.isValidElement(children) || Array.isArray(children)) {
    return /*#__PURE__*/React.createElement(StyledText, _extends({
      ref: ref
    }, props), processMixedContent(children));
  }
  return /*#__PURE__*/React.createElement(StyledText, _extends({
    ref: ref
  }, props), children);
});
Text.displayName = 'Text';
Text.propTypes = textPropTypes;
export default Text;
//# sourceMappingURL=Text.js.map